// assets/cart-upsell.js
(() => {
  let isAdding = false;

  const STORAGE_KEY = "avion_upsell_selections_v1";

  function moneyFormat() {
    return (
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      "{{amount}} €"
    );
  }

  function formatMoney(cents) {
    const fmt = moneyFormat();
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, fmt);
    }
    const value = (Number(cents || 0) / 100).toFixed(2);
    const withComma = value.replace(".", ",");
    return fmt
      .replace("{{amount_with_comma_separator}}", withComma)
      .replace("{{amount}}", value);
  }

  function loadSelections() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    } catch {
      return {};
    }
  }

  function saveSelections(map) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
      // ignore
    }
  }

  function cardFrom(el) {
    return el.closest("[data-upsell-card]");
  }

  function cardKey(card) {
    const titleLink = card.querySelector(".cart-upsell__title");
    const href = titleLink && titleLink.getAttribute("href");
    if (href) return `href:${href}`;

    const title = titleLink && titleLink.textContent ? titleLink.textContent.trim() : "";
    return `title:${title}`;
  }

  function variantsFrom(card) {
    const script = card.querySelector(".cart-upsell__variants-json");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error("Upsell variants JSON parse error", e);
      return null;
    }
  }

  function selectsFrom(card) {
    return Array.from(card.querySelectorAll(".cart-upsell__select"));
  }

  function selectedOptions(card) {
    return selectsFrom(card).map((s) => s.value);
  }

  function matchVariant(variants, options) {
    if (!Array.isArray(variants) || !variants.length) return null;
    return (
      variants.find(
        (v) =>
          Array.isArray(v.options) &&
          v.options.length === options.length &&
          v.options.every((opt, i) => opt === options[i])
      ) || null
    );
  }

  function ensureDefaultSelection(card, variants) {
    const selects = selectsFrom(card);
    if (!selects.length) return;

    const firstAvailable = variants.find((v) => v.available) || variants[0];
    if (!firstAvailable || !Array.isArray(firstAvailable.options)) return;

    selects.forEach((sel, idx) => {
      const desired = firstAvailable.options[idx];
      if (!desired) return;
      const opt = Array.from(sel.options).find((o) => o.value === desired);
      if (opt) sel.value = desired;
    });
  }

  function persistCardSelection(card) {
    const selects = selectsFrom(card);
    if (!selects.length) return;

    const key = cardKey(card);
    const map = loadSelections();
    map[key] = selects.map((s) => s.value);
    saveSelections(map);
  }

  function restoreCardSelection(card) {
    const selects = selectsFrom(card);
    if (!selects.length) return;

    const key = cardKey(card);
    const map = loadSelections();
    const values = map[key];

    if (!Array.isArray(values) || !values.length) return;

    values.forEach((val, idx) => {
      const sel = selects[idx];
      if (!sel) return;

      const opt = Array.from(sel.options).find((o) => o.value === val);
      if (opt) {
        sel.value = val;
        sel.dataset.userChanged = "1";
      }
    });
  }

  // -------------------------------------------------------
  // NEW: afbeelding automatisch wisselen op basis van variant
  // -------------------------------------------------------
  function getVariantImageSrc(variant) {
    if (!variant) return "";

    // Meest voorkomende Shopify shapes
    if (variant.featured_image && typeof variant.featured_image === "object") {
      if (variant.featured_image.src) return String(variant.featured_image.src);
      if (variant.featured_image.url) return String(variant.featured_image.url);
    }

    // Soms is het direct een string of andere velden
    if (typeof variant.featured_image === "string") return String(variant.featured_image);
    if (variant.image) return String(variant.image);
    if (variant.image_src) return String(variant.image_src);

    // Media-style shape
    if (
      variant.featured_media &&
      variant.featured_media.preview_image &&
      variant.featured_media.preview_image.src
    ) {
      return String(variant.featured_media.preview_image.src);
    }

    return "";
  }

  function updateCardImage(card, variant) {
    const src = getVariantImageSrc(variant);
    if (!src) return;

    // Gebruik liefst een vaste selector in uw upsell markup:
    // <img data-upsell-image ...>
    // Anders vallen we terug op bekende classes.
    const img =
      card.querySelector("img[data-upsell-image]") ||
      card.querySelector("[data-upsell-image] img") ||
      card.querySelector(".cart-upsell__image img") ||
      card.querySelector(".cart-upsell__media img") ||
      card.querySelector("img");

    if (!img) return;

    const current = img.getAttribute("src") || "";
    if (current === src) return;

    img.setAttribute("src", src);

    // Voorkom dat de browser via srcset toch een oude afbeelding kiest
    if (img.hasAttribute("srcset")) img.removeAttribute("srcset");
    if (img.hasAttribute("sizes")) img.removeAttribute("sizes");
  }

  function updateCard(card) {
    const variants = variantsFrom(card);
    const btn = card.querySelector("[data-upsell-add]");
    const priceEl = card.querySelector("[data-upsell-price]");
    const compareEl = card.querySelector("[data-upsell-compare]");

    // Geen variants-json betekent: default variant uit data-variant-id gebruiken
    if (!variants) {
      if (btn) {
        const fallbackId = btn.getAttribute("data-variant-id");
        if (fallbackId) btn.dataset.variantId = String(fallbackId);
        btn.disabled = false;
      }
      return;
    }

    const selects = selectsFrom(card);
    const alreadyChosen = selects.some((s) => s.dataset.userChanged === "1");
    if (!alreadyChosen) ensureDefaultSelection(card, variants);

    const opts = selectedOptions(card);
    const variant = matchVariant(variants, opts);

    if (!variant) {
      if (btn) {
        btn.disabled = true;
        btn.dataset.variantId = "";
      }
      return;
    }

    // NEW: update image to match selected color/variant
    updateCardImage(card, variant);

    if (btn) {
      btn.dataset.variantId = String(variant.id);
      btn.disabled = !variant.available;
    }

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = "";
      } else {
        compareEl.textContent = "";
        compareEl.style.display = "none";
      }
    }
  }

  function init(root = document) {
    root.querySelectorAll("[data-upsell-card]").forEach((card) => {
      restoreCardSelection(card);
      updateCard(card);
    });
  }

  function getDrawerCount() {
    // probeer een paar bekende plekken voor cart count
    const el =
      document.querySelector("[ref='cartItemCount']") ||
      document.querySelector("[data-cart-count]") ||
      document.querySelector(".cart-count-bubble") ||
      document.querySelector("#cart-icon-bubble");
    if (!el) return null;
    const text = (el.textContent || "").trim();
    const n = Number(text.replace(/[^\d]/g, ""));
    return Number.isFinite(n) ? n : null;
  }

  async function safeRefreshAfterAdd(beforeCount) {
    if (typeof window.AvionUpsellRefreshCartUI !== "function") {
      window.location.reload();
      return;
    }

    await window.AvionUpsellRefreshCartUI();

    // sanity check: als count niet wijzigt, nog één keer proberen
    const afterCount = getDrawerCount();
    if (beforeCount != null && afterCount != null && afterCount === beforeCount) {
      // een 2e refresh vangt themes op die pas na 1e DOM swap “bijtrekken”
      await window.AvionUpsellRefreshCartUI();

      const after2 = getDrawerCount();
      if (after2 != null && after2 === beforeCount) {
        // ultieme fallback
        window.location.reload();
      }
    }
  }

  document.addEventListener("change", (e) => {
    const sel = e.target.closest(".cart-upsell__select");
    if (!sel) return;

    sel.dataset.userChanged = "1";

    const card = cardFrom(sel);
    if (!card) return;

    persistCardSelection(card);
    updateCard(card);
  });

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-upsell-add]");
    if (!btn) return;

    if (isAdding) return;

    const card = cardFrom(btn);
    if (!card) return;

    const id = Number(btn.dataset.variantId || btn.getAttribute("data-variant-id"));
    if (!id) return;

    isAdding = true;

    const prevDisabled = btn.disabled;
    btn.disabled = true;

    const beforeCount = getDrawerCount();

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id, quantity: 1 }),
      });

      if (!res.ok) {
        const errText = await res.text().catch(() => "");
        throw new Error(errText || "Add failed");
      }

      await safeRefreshAfterAdd(beforeCount);
    } catch (err) {
      console.error("Upsell add-to-cart failed:", err);
      btn.disabled = prevDisabled;
    } finally {
      isAdding = false;
    }
  });

  document.addEventListener("cart:refresh", () => init(document));
  document.addEventListener("cart:updated", () => init(document));
  document.addEventListener("cart:change", () => init(document));

  function observeUpsellMount() {
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            node.matches?.("[data-upsell-card], .cart-upsell, #CartDrawer, cart-drawer, cart-drawer-component") ||
            node.querySelector?.("[data-upsell-card]")
          ) {
            init(document);
            return;
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  observeUpsellMount();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }
})();